module.exports = new __parcel__URL__("google-workspace-logo.effa87cc.png").toString();